module.exports = {"consultations.title":"Consultaties"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/nl.json
// module id = 1322
// module chunks = 0